import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { CookieService } from "ngx-cookie-service";
import { PushNotificationService } from "src/app/shared/services/push-notification.service";
import { IncomingCallComponent } from "./incoming-call/incoming-call.component";
import { APIService } from "src/app/shared/services/api.service";
import { Constants } from "src/app/shared/constants";
import { CommonService } from 'src/app/shared/services/common.service';
import { AppConfigService } from "src/app/shared/services/app-config/app-config.service";
import { OngoingCallComponent } from "./ongoing-call/ongoing-call.component";

@Injectable({
    providedIn: 'root'
})
export class ElevatorCallService {

    constructor(private _pushNotificationService: PushNotificationService, 
        private _localCookies: CookieService, private _dialog: MatDialog, 
        private _apiService: APIService, private _commonService: CommonService) { }

    closePushNotification() {
        this._pushNotificationService.closeNotification(this._localCookies.get('CCApp-elevatorID'));
    }
    openDialog(data?: any): void {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '600px';
        dialogConfig.height = '500px';
        dialogConfig.data = data;

        const dialogRef = this._dialog.open(IncomingCallComponent, dialogConfig);

        dialogRef.afterClosed().subscribe((result: any) => {

        });
    }
    getVideoStats() {
        return { enabledEle: false, auto: false, frameMessage: '', enableAgentVideo: true, remAudioBytesReceived: '', remAudioCodec: '', remVideoBytesReceived: '', remVideoCodec: '', RemFramesRate: '', remDimension: '', remPacketsLost: 0, remPacketsReceived: 0, remSSRC: 0, remJitter: 0, remAudioPocketReceived: 0, remAudioPocketLost: 0, remAudioSSRC: 0, locAudioBytesReceived: '', locAudioCodec: '', locVideoBytesReceived: '', locVideoCodec: '', locFramesRate: '', locDimension: '', locPacketsLost: 0, locPacketsSent: 0, locRoundTripTime: 0, locSSRC: 0, locJitter: 0, locAudioPocketSent: 0, locAudioPocketLost: 0, locAudioRoundTripTime: 0, locAudioSSRC: 0 };
    }
    updateCall(payload: any) {
        return this._apiService.post(payload, Constants.elevator_call_URLS.updateCall)
    }
    insertChatMsgDetails(payload: any) {
        return this._apiService.post(payload, Constants.elevator_call_URLS.insertChatMsgDetails)
    }
    insertCallDetails(payload: any) {
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - insertCallDetails" }, { url: Constants.elevator_call_URLS.insertCallDetails, payload: payload });
        return this._apiService.post(payload, Constants.elevator_call_URLS.insertCallDetails);
      }
    getElevatorDetailsFromG3MS(payload: any) {
        let url = Constants.G3MS_URLS.getElevatorInfo + `?countryName=${payload.countryName}&countryShortName=${payload.countryShortName}&elevatorId=${payload.elevatorId}&findex=${payload.findex}&shortElevatorId=${payload.displayElevatorId}`
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - getElevatorDetailsFromG3MS" }, { url: url, payload: payload });
        return this._apiService.post(payload, url);
    }
    updateCallDetails(payload: any) {        
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - updateCallDetails" }, { url: Constants.elevator_call_URLS.updateCallDetails, payload: payload });
        return this._apiService.post(payload, Constants.elevator_call_URLS.updateCallDetails);
      }
      callBackElevatorFromG3MS(payload: any) {
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - callBackElevatorFromG3MS" }, { url: Constants.G3MS_URLS.callbackFromElevator, payload: payload });
        return this._apiService.post(payload, Constants.G3MS_URLS.callbackFromElevator);
      }
      getIdentityToken(payload: any) {
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - getIdentityToken" }, { url: Constants.elevator_call_URLS.updateCallDetails, payload: payload });
        return this._apiService.post(payload, Constants.elevator_call_URLS.getIdentityToken);
      }
      getWorkersForSupervisor(payload: any) {
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - getWorkersForSupervisor" }, { url: Constants.elevator_call_URLS.getWorkersForSupervisor, payload: payload });
        return this._apiService.post(payload, Constants.elevator_call_URLS.getWorkersForSupervisor);
      }
      transferCall(payload: any) {
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - transferCall" }, { url: Constants.elevator_call_URLS.callTransfer, payload: payload });
        return this._apiService.post(payload, Constants.elevator_call_URLS.callTransfer);
      }
      saveDispositionDetails(payload: any) {
        AppConfigService.trackEvent("logServices", { name: "ElevatorCallService - saveDispositionDetails" }, { url: Constants.call_disposition_URLS.saveCallDisposition, payload: payload });
        return this._apiService.post(payload, Constants.call_disposition_URLS.saveCallDisposition);
      }
}